module.exports = __webpack_public_path__ + "media/images/emblems/Homburg_neu-c36d5fed8d206a80156e63315f82f3cb.png";